export interface OnLayoutChanged{
    layoutChanged(layout: Layout);
}
export enum Layout{
    VIDEOS_WB, AUDIO_WB, TEACHER_PRESENTATION_BOTH, TEACHER_PRESENTATION_AUDIO, NONE, AUDIO_SNAPSHOTS
}
export interface ILayoutManager{
    onLayout(layout);
    getLayout():Layout;
    onInitalLayout(layout);
 sendResize(to);
 resize();
 setFullscreen(to);
 onFullscreen(to);
}


// WEBPACK FOOTER //
// /app/src/app/wb/services/layout/layout-manager.ts